import { ToastProvider } from '@greensm/ui';
import { Outlet } from 'react-router-dom';
import { useOnline } from '@/shared/lib/hooks';

/**
 * Khung điện thoại (mobile-first). Trên máy tính hiển thị như thiết bị ở giữa màn hình;
 * trên điện thoại chiếm toàn màn hình. Toast và sheet neo theo khung này.
 */
export function AppFrame() {
  const online = useOnline();
  return (
    <div className="app-frame">
      <ToastProvider>
        {!online && (
          <div className="g-banner g-banner--warn app-offline" role="status">
            Bạn đang ngoại tuyến. Các thao tác cần mạng sẽ được thử lại khi có kết nối.
          </div>
        )}
        <Outlet />
      </ToastProvider>
    </div>
  );
}
